import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('properties-medias', storeModule.createStoreModule('properties-medias'))
